export const getPromoCacheKey = (partNumber: string, userGlobalId?: string) => {
    return `${partNumber}${userGlobalId ? `|${userGlobalId}` : ''}`;
}